import { CheckRes } from "../types/types"

// --------------------------------------------------------------------------------

export const getErrors = (checkRes?: CheckRes) => {

    let warnings = false
    let errors = false

    if (!checkRes) return { warnings, errors }

    Object.values(checkRes.result).forEach(result => {
        Object.values(result.errors).forEach(errs => {
            errs.forEach(err => {
                if (err.actionId === 2)
                    warnings = true
                if (err.actionId === 3)
                    errors = true
            })
        })
    })

    return { warnings, errors } as const
}